export default function BrandLogoContainer({ alt = "Big Taxi", className = "", src }) {
  return (
    <div className={`brand-logo-container ${className}`.trim()} aria-label={alt}>
      <img src={src} alt={alt} />
    </div>
  );
}
